import { Button, Container, Grid2, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Select from "components/common/Select";
import StatusHandler from "components/common/StatusHandler";
import { PdfViewer } from "components/fileViewers/container";
import { FilmCardView } from "components/film";
import log from "loglevel";
import { ReportLogTable } from "./container";

function LogReport({
    filmReleases,
    onLoadReportView,
    onClear,
    onFilterByType,
    onRemoveFilm,
    advertisementTypes,
    onShowComments,
    showComments,
    loadingStatus,
    onGeneratePdf,
}) {
    const [showComment, setShowComments] = useState(showComments);
    const [type, setType] = useState(null);

    useEffect(() => {
        log.debug(filmReleases);
        if (filmReleases.length) {
            onLoadReportView();
        }
    }, []);

    function handleViewReport() {
        onGeneratePdf(true);
    }

    function handleCommentChange() {
        setShowComments(!showComment);
        onShowComments(!showComment);
    }

    function handleOnClear() {
        onClear();
    }

    function handleOnRemoveFromList(id) {
        onRemoveFilm(id);
    }
    function handleTypeChange(_type) {
        setType(_type);
        onFilterByType(_type ? _type : null);
    }

    const previewTitle = "ATS Log Sheet Report";

    function renderDetails(filmRelease) {
        return <ReportLogTable showAdvType={false} filmReleaseId={filmRelease.id} />;
    }
    const btnView = (
        <Button
            variant={"contained"}
            style={{ marginLeft: 10 }}
            disabled={filmReleases.length === 0}
            onClick={handleViewReport}
            color={"secondary"}
        >
            View Report
        </Button>
    );
    const btnClear = (
        <Button variant={"outlined"} onClick={handleOnClear} style={{ marginLeft: 10 }}>
            Clear Report
        </Button>
    );

    return (
        (<Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <StatusHandler status={loadingStatus} showLoading />
            <Grid2 container spacing={3}>
                <Grid2 style={{ textAlign: "right" }} size={12}>
                    <Paper style={{ padding: 7 }}>
                        <span style={{ textAlign: "left", float: "left", width: 200 }}>
                            <Select
                                options={advertisementTypes}
                                placeholder={"Filter by Type"}
                                value={type}
                                defaultMenuPortalTarget
                                onChange={handleTypeChange}
                            />
                        </span>

                        <FormControlLabel
                            control={<Switch checked={showComment} onChange={handleCommentChange} color="secondary" />}
                            label="Show comments"
                        />
                        {btnClear}
                        {btnView}
                    </Paper>
                </Grid2>

                <Grid2 size={12}>
                    {filmReleases.map((filmRelease) => {
                        return (
                            <FilmCardView
                                lazyLoad={false}
                                editable={false}
                                key={filmRelease.id}
                                listItem
                                expandable={false}
                                defaultExpanded={true}
                                showActions={false}
                                onRemove={handleOnRemoveFromList}
                                renderDetails={() => renderDetails(filmRelease)}
                                filmRelease={filmRelease}
                            />
                        );
                    })}
                </Grid2>
            </Grid2>
            <PdfViewer title={previewTitle} />
        </Container>)
    );
}

export default LogReport;
